import { Controller } from "@hotwired/stimulus";
import { Fancybox } from "@fancyapps/ui/src/Fancybox";

export default class extends Controller {
  connect() {
  
    this.openModal();
  }

  disconnect() {
  
    if (this.fb) {
      this.fb.destroy();
      this.fb = null;
    }
  }

  openModal() {
    if (this.fb) {
      
      return;
    }

    const el = document.getElementById("password_change");
    if (!el) {
      
      return;
    }

  

    this.fb = Fancybox.show([{
      src: "#password_change",
      type: "inline",
    }], {
      touch: false,
      closeButton: false,
      dragToClose: false,
    });

    this.fb.on("shouldClose", () => false);
 
  }
}